const formElem = document.querySelector(".js-form-step-1");

if (formElem) {
    $(formElem).validate({
        submitHandler: function (form) {
            $(form).find('button[type="submit"]').prop("disabled", true).addClass("is-loading");

            form.submit();
        },
    });
}
const sortedSwitch = document.querySelector(".js-sorted-switch");

if (sortedSwitch) {
    let selectedOption = getCookie("cartSorted") === "true";

    sortedSwitch.addEventListener("click", function () {
        setCookie("cartSorted", !selectedOption);
        location.reload();
    });
}
